import React from 'react';
import { MessageCircle } from 'lucide-react';

const PHONE = '447547340708'; // UK international format
const MESSAGE = 'Hi GiCleanly! I\u2019d like to book a cleaning service.';

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
      <span className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1fbd5a] text-white flex items-center justify-center shadow-lg shadow-[#25D366]/40 transition-colors">
        <MessageCircle size={26} fill="white" strokeWidth={0} className="absolute" />
        <svg viewBox="0 0 32 32" className="w-7 h-7 relative" fill="currentColor">
          <path d="M16.001 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.47 1.74 6.42L3.2 28.8l6.55-1.71a12.75 12.75 0 006.25 1.62h.01c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.71-12.81-12.71zm0 23.35h-.01a10.53 10.53 0 01-5.36-1.47l-.38-.23-3.89 1.02 1.04-3.79-.25-.39a10.55 10.55 0 01-1.62-5.63c0-5.83 4.75-10.58 10.58-10.58 2.83 0 5.48 1.1 7.48 3.1a10.5 10.5 0 013.1 7.48c-.01 5.83-4.76 10.49-10.69 10.49zm5.79-7.87c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16s-.82 1.03-1 1.24c-.19.21-.37.23-.68.08-.32-.16-1.34-.49-2.55-1.57-.94-.84-1.58-1.87-1.77-2.19-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.55-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54-.19-.01-.4-.01-.61-.01s-.55.08-.84.4c-.29.32-1.11 1.08-1.11 2.63s1.14 3.05 1.29 3.26c.16.21 2.24 3.42 5.42 4.79.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.26-.74.26-1.37.19-1.51-.08-.14-.29-.21-.61-.37z" />
        </svg>
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-white text-[#1a2851] text-sm font-medium px-3 py-2 rounded-lg shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us
      </span>
    </a>
  );
}
